import { AppConstants } from '@ltvco/refresh-lib/ctx';
import { Stack, Text, Divider, Tooltip } from '@ltvco/refresh-lib/theme';
import { useContext } from 'react';

import { PLAN_DISPLAY } from '../../constants';
import { OrderSummaryCard } from '../components';

export const OrderSummary = () => {
  const { images } = useContext(AppConstants);
  const extendedImages = images as any;

  return (
    <OrderSummaryCard>
      <Text variant="h4" fontWeight={700}>
        ORDER SUMMARY
      </Text>
      <Divider sx={{ my: 1 }} />
      <Stack spacing={1}>
        <Stack direction="row" justifyContent="space-between">
          <Text variant="body1">7 Day Trial Membership</Text>
        </Stack>
        <Divider sx={{ my: 1 }} />
        <Stack direction="row" justifyContent="space-between">
          <Text variant="body1">All-Access</Text>
          <Text variant="body1">3 Search Types</Text>
        </Stack>
        <Divider sx={{ my: 1 }} />
        <Stack direction="row" justifyContent="flex-end">
          <Text variant="body1" fontWeight={700}>
            Total Today:
          </Text>
          <Text variant="body1" fontWeight={700}>
            &nbsp;{PLAN_DISPLAY.totalToday}*
          </Text>
        </Stack>
        <Stack direction="row" justifyContent="flex-end" alignItems="center">
          <Text variant="caption" color="text.secondary">
            Plus applicable sales tax&nbsp;
          </Text>
          <Tooltip
            title="Depending on your state's requirements, sales taxes may apply to your order."
            arrow
            placement="left"
          >
            <img
              src={extendedImages.subscribePage.questionMark}
              alt="question mark"
              height={16}
            />
          </Tooltip>
        </Stack>
      </Stack>
    </OrderSummaryCard>
  );
};
